/*
--------------------
AD STACK MANAGER
--------------------

Manages the interactions between all of our adtech

TODO - https://www.npmjs.com/package/local-storage
TODO - ADD THE ABOVE LIBRARY
*/

import DFP from './adtech/dfp.js';
// import FanOf from './adtech/fan-of.js';
// import HeaderBidding from './adtech/header-bidding';
import LazyAds from './adtech/lazy-ads.js';
// import Lotame from './adtech/lotame.js';







class AdStack{

  constructor() {

    this.addGlobalTargeting = this.addGlobalTargeting.bind(this);
    this.addSingleTargeting = this.addSingleTargeting.bind(this);
    this.queueCallback = this.queueCallback.bind(this);
    this.setAdTechReady = this.setAdTechReady.bind(this);
    this.initial_setup = this.initial_setup.bind(this);
    this.setup = this.setup.bind(this);
    this.unloadAllAds = this.unloadAllAds.bind(this);
    this.unloadLabeledAds = this.unloadLabeledAds.bind(this);
    this.unloadAdsWithIdentifier = this.unloadAdsWithIdentifier.bind(this);

    this.initial_setup();

  }

  // Single run setup, should only be run when AdManager is first getting set up
  // This is where we set up things like script fetches
  initial_setup() {

    this.DFP = DFP();
    this.LazyAds = LazyAds();

    // Callbacks which are waiting for ads to be ready. Keep this internal
    this.callbackQueue = [];

    // External Callback queue.
    this.externalCallbackQueue = [];
    this.adTechReady = false;


    this.DFPScriptFetched = new Promise(resolve => {
      this.DFP.fetchScript(resolve);
    });

    // Ensures DFP is correctly set up and ready to rock
    this.DFPInitialised = new Promise(resolve => {
      this.DFP.initDFP(resolve);
    });

    Promise.all([this.DFPInitialised])
      .then(() => {
        // Apply any additional targeting from HeaderBidding
        this.DFP.enableServices();
      });

    this.setup();

  }

  // Re-runnable method to clear configs and run ad initialisation/targeting
  setup() {
    this.adTechReady = false;
    this.globalTargeting = window.AdManager.globalTargeting || [];
    this.singleTargeting = window.AdManager.singleTargeting || [];
    this.unactionedGlobalTargeting =
      window.AdManager.unactionedGlobalTargeting || [];
    this.unactionedSingleTargeting =
      window.AdManager.unactionedSingleTargeting || [];


    Object.keys(this.globalTargeting).forEach(keyName => {
      this.unactionedGlobalTargeting[keyName] = this.globalTargeting[keyName];
    });

    // Raw adslots, before they're initialised
    this.adSlots = window.AdManager.adSlots || [];
    this.unactionedAdSlots = window.AdManager.unactionedAdSlots || [];

    // Definitions created by DFP
    this.adDefinitions = window.AdManager.adDefinitions || [];

    window.AdManager = this;

    // Define the screensizes
    // Small breakpoint is  0 to 767px
    // Medium breakpoint is 768px to 991px
    // Large breakpoint is 992px to 1199px
    // XLarge breakpoint is 1200px up
    const screenSize = (() => {
      if (window.innerWidth <= 375) {
        return 'small_phone';
      }

      if (window.innerWidth > 375 && window.innerWidth <= 767) {
        return 'large_phone';
      }

      if (window.innerWidth > 767 && window.innerWidth <= 991) {
        return 'tablet';
      }

      if (window.innerWidth > 991 && window.innerWidth <= 1200) {
        return 'desktop';
      }

      return 'large_desktop';
    })();
    this.addGlobalTargeting('screenSize', screenSize);

    let fnPageskin = 'false';
    if (typeof screen !== 'undefined' && screen.width >= 375) {
      fnPageskin = 'true';
    }
    this.addGlobalTargeting('inskin_yes', fnPageskin);

    Promise.all([this.DFPInitialised])
      .then(() => {
        console.log("------------ DFPInitialised PROMISE FULFILLED ------------------")
        // Apply any additional targeting from HeaderBidding
        this.queueCallback(this.LazyAds.startLazyAds);
        this.DFP.applyTargeting();
        this.DFP.initAdSlots();
        this.setAdTechReady();
      });


  }


  // Add a global targeting parameter
  addGlobalTargeting(targetingKey, targetingValue) {
    this.globalTargeting[targetingKey] = targetingValue;
    this.unactionedGlobalTargeting[targetingKey] = targetingValue;

    if (this.adTechReady === true) {
      this.DFP.applyTargeting();
    }

    return this.globalTargeting;
  }

  // Add a targeting parameter for a single adslot
  addSingleTargeting(targetingKey, targetingValue, id) {
    if (typeof this.singleTargeting[id] !== 'object') {
      this.singleTargeting[id] = {};
    }
    if (typeof this.unactionedSingleTargeting[id] !== 'object') {
      this.unactionedSingleTargeting[id] = {};
    }
    this.singleTargeting[id][targetingKey] = targetingValue;
    this.unactionedSingleTargeting[id][targetingKey] = targetingValue;
    return this.singleTargeting;
  }

  // Unloads all ads
  // Returns an array of all AdManager definitions which have been unloaded
  unloadAllAds() {

    // First, deep copy all of the declarations
    // Then reset adSlots to its initial empty state
    const adDeclarations = JSON.parse(JSON.stringify(this.adSlots));
    this.adSlots = [];
    // console.log(adDeclarations);

    // Remove the ads from pubads too
    this.DFP.unloadAllAds();

    return adDeclarations;

  }

  // Unload only pixel, header and sticky ads (which may contains DFP competition Exclusion label)
  unloadLabeledAds() {
    try {
      let adSlotsToClean = [];
      //only unload the 1x1, desktop_header and mobile header ads.
      this.adSlots.forEach( targetAd => {
        if(targetAd.metadata.div.includes('pixel')
          || targetAd.metadata.div.includes('header')
          || targetAd.metadata.div.includes('sticky')) {
          adSlotsToClean.push(targetAd);
        }
      });
      this.DFP.unloadAds(adSlotsToClean,()=>{});
    } catch (e) {
      console.log(e);
    }
  }


  unloadAdsWithIdentifier(uniqueIdentifier, callback) {

    //console.log("UNLOADING ADS WITH IDENTIFIER  -   " + uniqueIdentifier);

    this.adTechReady = false;

    if(typeof callback === 'undefined') {
      callback = () => {console.log("DUMMY CALLBACK");}
    }

    const adsToRemove = [];

    for(let x = this.adSlots.length - 1; x > -1; x --) {
      if(this.adSlots[x].uniqueIdentifier  === uniqueIdentifier) {
        // this.adSlots[x].metadata.loaded = false;
        adsToRemove.push(this.adSlots[x]);

        this.adSlots.splice(x, 1);
      }
    }

    this.LazyAds.destroyIntersectionObservers();
    this.DFP.unloadAds(adsToRemove, callback);

    return adsToRemove;

  }



  // Add to callbacks which execute when ads are ready. If ads are already ready, then just fire the callback immediately.
  queueCallback(callback, external = false) {
    if (this.adTechReady) {
      callback();
    } else if (external) {
      this.externalCallbackQueue.push(callback);
    } else {
      this.callbackQueue.push(callback);
    }
  }

  // Mark ad-tech as ready to go
  setAdTechReady() {
    this.callbackQueue.forEach(callback => {
      callback();
    });
    this.callbackQueue = [];
    this.externalCallbackQueue.forEach(callback => {
      callback();
    });
    this.externalCallbackQueue = [];
    this.adTechReady = true;
  }

}

export default () => new AdStack();
